import React, { useContext } from "react";

import { ChatContext } from "components/Chat/ChatContext";

import ReadMoreText from "components/ReadMoreText";

interface Props {
	messageId?: string;
	text: string;
	partnersUid: string;
	patnersDisplayName: string;
	dateSent?: Date;
}

const OpenChatAtMessageButton: React.FunctionComponent<Props> = ({
	messageId,
	text,
	partnersUid,
	patnersDisplayName,
	dateSent
}) => {
	const [, setChatDetails] = useContext(ChatContext);

	return (
		<ReadMoreText
			text={text}
			max={20}
			onClick={() => {
				setChatDetails({
					partner: {
						uid: partnersUid,
						displayName: patnersDisplayName
					},
					pagination: {
						cursorType: "after",
						cursor: dateSent ? new Date(dateSent.getTime() - 1) : undefined
					},
					highlightedMessageId: messageId
				});
			}}
		/>
	);
};

export default OpenChatAtMessageButton;
